export enum InputType {
  Text = 'Text',
  Number = 'Number',
  Checkbox = 'Checkbox',
  Radiobutton = 'Radiobutton',
  Select = 'Select',
  Multiselect = 'Multiselect',
  Range = 'Range',
  DateRange = 'DateRange',
}
